module.exports = __webpack_public_path__ + "static/media/light-theme-fuel.838cf578.svg";